<template>
  <div class="vlt-404">
    <img :src="poster" width="100%" height="100%;" alt="poster"/>
    <div class="sec-404">
      <img class="errorimage" src="@/assets/icons/404-number.png" alt="404 image"/>
      <div class="row">
        <div class="col-lg-2 col-md-1 col-sm-0"></div>
        <div class="col-lg-5 col-md-5 col-sm-5">
          <p class="go-home" @click="goHome">GO HOME</p>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-0"></div>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <p class="oops">Oops! Sorry Page not found.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Page404',
  components: {
  },
  data () {
    return {
      poster : require('@/assets/icons/404.png')
    }
  },
  methods: {
    goHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss">
@import '~sass/modules/variables';
.vlt-404{
  height: 100%;
}

.sec-404 {
    position: absolute;
    z-index: 100;
    top: 40%;
    left: 12%;
    .errorimage{
      width: 80%;
    }
    
    p{      
      font-family: "HelveticaNeueMedium";	
      color: #FFFFFF;	
       font-size: 30px;	
      font-weight: 500;
    }
    .go-home{
      margin: 50px 0 20px 0;
      line-height: 39px;	
      border: 2px solid;
      text-align: center;
      font-weight: bold;
      cursor: pointer;
    }
    .oops{
      margin: 15px 0;     	
      line-height: 37px;
      text-align: start;
    }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) 
{
  .sec-404 {
    top: 30%;
    .errorimage{
      width: 50%;
    }
    p{
      font-size: 10px;
    }
    .go-home{
      margin: 20px 0 10px 0;
    }
  }
}
/* Extra small devices (tablet, 768px and down) */
@media only screen and (max-width: 768px)
{
  .sec-404 {
    .errorimage{
      width: 50%;
    }
    p{
      font-size: 20px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Page404/Page404.vue